export default __webpack_public_path__ + "static/media/video-off-red.3bcc2e06.svg";